const SETUP = {
  CHECK_STATUS:
    'Initialization is in process for more detail run getMigrationStatus query to get the status of the migration',
};

export default SETUP;
